/* KaminWelt — Merkliste. Speichert Produkt-Handles im Browser (localStorage). */
(function () {
  if (window.__kwWish) return;
  window.__kwWish = true;

  var KEY = 'kw_wish';
  var HEART = '<svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linejoin="round"><path d="M20.8 4.6a5.5 5.5 0 0 0-7.8 0L12 5.7l-1-1.1a5.5 5.5 0 1 0-7.8 7.8l1 1.1L12 21.2l7.8-7.7 1-1.1a5.5 5.5 0 0 0 0-7.8z"/></svg>';

  function read() {
    try { var v = JSON.parse(localStorage.getItem(KEY) || '[]'); return Array.isArray(v) ? v : []; }
    catch (e) { return []; }
  }
  function write(list) {
    try { localStorage.setItem(KEY, JSON.stringify(list)); } catch (e) {}
  }

  function paintCount() {
    var n = read().length;
    Array.prototype.forEach.call(document.querySelectorAll('[data-kw-wish-count]'), function (el) {
      el.textContent = n;
      el.style.display = n ? '' : 'none';
    });
  }

  function paintButtons() {
    var list = read();
    Array.prototype.forEach.call(document.querySelectorAll('[data-kw-wish]'), function (b) {
      var on = list.indexOf(b.getAttribute('data-kw-wish')) > -1;
      b.setAttribute('aria-pressed', on ? 'true' : 'false');
      b.classList.toggle('is-on', on);
      b.setAttribute('title', on ? 'Von der Merkliste entfernen' : 'Zur Merkliste hinzufügen');
    });
  }

  function toggle(handle) {
    var list = read();
    var i = list.indexOf(handle);
    if (i > -1) list.splice(i, 1); else list.push(handle);
    write(list);
    paintCount();
    paintButtons();
    if (document.querySelector('[data-kw-wishlist]')) renderList();
  }

  function money(cents) {
    var n = cents / 100;
    try { return '€' + n.toLocaleString('de-DE', { minimumFractionDigits: 2, maximumFractionDigits: 2 }); }
    catch (e) { return '€' + n.toFixed(2); }
  }

  function sized(url, w) {
    if (!url) return '';
    if (url.indexOf('//') === 0) url = 'https:' + url;
    return url + (url.indexOf('?') > -1 ? '&' : '?') + 'width=' + w;
  }

  function esc(s) {
    return String(s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
  }

  function card(p) {
    var url = '/products/' + p.handle;
    return '<article class="kw-card">'
      + '<div class="kw-card__media">'
      + '<button class="kw-card__wish is-on" type="button" aria-pressed="true" data-kw-wish="' + esc(p.handle) + '" aria-label="Von der Merkliste entfernen">' + HEART + '</button>'
      + '<a href="' + url + '"><img src="' + sized(p.featured_image, 600) + '" alt="' + esc(p.title) + '" loading="lazy" width="600" height="600"></a>'
      + '</div>'
      + '<div class="kw-card__body">'
      + '<a class="kw-card__title" href="' + url + '">' + esc(p.title) + '</a>'
      + (p.vendor ? '<span class="kw-card__sub">' + esc(p.vendor) + '</span>' : '')
      + '<div class="kw-card__foot">'
      + '<div><span class="kw-price">' + money(p.price) + '</span></div>'
      + '<a class="kw-btn kw-btn--primary kw-wish__go" href="' + url + '">Ansehen</a>'
      + '</div></div></article>';
  }

  function renderList() {
    var box = document.querySelector('[data-kw-wishlist]');
    if (!box) return;
    var empty = document.querySelector('[data-kw-wish-empty]');
    var list = read();
    if (!list.length) {
      box.innerHTML = '';
      if (empty) empty.hidden = false;
      return;
    }
    if (empty) empty.hidden = true;
    Promise.all(list.map(function (h) {
      return fetch('/products/' + encodeURIComponent(h) + '.js')
        .then(function (r) { return r.ok ? r.json() : null; })
        .catch(function () { return null; });
    })).then(function (items) {
      var ok = items.filter(Boolean);
      if (!ok.length) {
        box.innerHTML = '';
        if (empty) empty.hidden = false;
        return;
      }
      if (empty) empty.hidden = true;
      box.innerHTML = ok.map(card).join('');
      paintButtons();
    });
  }

  document.addEventListener('click', function (e) {
    var b = e.target.closest ? e.target.closest('[data-kw-wish]') : null;
    if (!b) return;
    e.preventDefault();
    e.stopPropagation();
    toggle(b.getAttribute('data-kw-wish'));
  });

  function init() {
    paintCount();
    paintButtons();
    renderList();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
